<template>
  <div>
    <v-card outlined raised width="100%" color="cyan accent-4" elevation="10">
      <p class="title text-center white--text">Contractor Summary</p>
      <v-row justify="space-between" no-gutters>
        <v-col cols="2">
          <stat-card
            title="Job Count"
            color="light-blue lighten-4"
            :amount="jobCount"
            icon="mdi-truck-delivery-outline"
            sub_title=""
          ></stat-card>
        </v-col>
        <v-col cols="2">
          <stat-card
            title="Misc Count"
            color="light-blue lighten-4"
            :amount="miscCount"
            icon="mdi-pencil-plus-outline"
            sub_title=""
          ></stat-card>
        </v-col>
        <v-col cols="2">
          <stat-card
            title="Toll"
            color="light-blue lighten-4"
            :amount="toll"
            icon="mdi-gauge"
            sub_title=""
          ></stat-card>
        </v-col>
        <v-col cols="2">
          <stat-card
            title="Fuel Levy"
            color="light-blue lighten-4"
            :amount="fuelLevy"
            icon="mdi-gas-station-outline"
            sub_title=""
          ></stat-card>
        </v-col>

        <v-col cols="2">
          <stat-card
            title="GST"
            color="light-blue lighten-4"
            :amount="gst"
            icon="mdi-office-building"
            sub_title=""
          ></stat-card>
        </v-col>

        <v-col cols="2">
          <stat-card
            title="Total"
            color="light-blue lighten-4"
            :amount="total"
            icon="directions_run"
            sub_title=""
          ></stat-card>
        </v-col>
      </v-row>

      <v-data-table
        dense
        :headers="headers"
        :items="contractorSummary"
        :loading="loadingContractorSummary"
        class="ma-5"
        :footer-props="{
          'items-per-page-options': [10, 20, 50, -1],
        }"
        :items-per-page="itemsPerPage"
      >
        <template v-slot:item="props">
          <tr class="pa-0">
            <td class="body-2">{{ props.item.ContractorID }}</td>
            <td class="body-2">{{ props.item.Name }}</td>
            <td align="right" class="body-2">{{ props.item.Jobs }}</td>
            <td align="right" class="body-2">{{ props.item.Misc }}</td>
            <td align="right" class="body-2">
              $ {{ formatSum(props.item.SubTotal) }}
            </td>
            <td align="right" class="body-2">
              $ {{ formatSum(props.item.Toll) }}
            </td>
            <td align="right" class="body-2">
              $ {{ formatSum(props.item.FuelLevy) }}
            </td>
            <td align="right" class="body-2">
              $ {{ formatSum(props.item.GST) }}
            </td>
            <td align="right" class="body-2">
              $ {{ formatSum(props.item.Total) }}
            </td>
          </tr>
        </template>
        <template v-slot:no-results>
          <v-alert :value="true" color="error" icon="warning"
            >Your search for "{{ search }}" found no results.</v-alert
          >
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import StatCard from "./StatCard.vue";

export default {
  components: {
    StatCard,
  },

  data: () => ({
    itemsPerPageOptions: [10, 20, 50, -1],
    contractorSummary: [],
    loadingContractorSummary: false,
    errors: [],
    headers: [
      {
        value: "ContractorID",
        align: "left",
        sortable: true,
        text: "ContractorID",
      },
      {
        value: "Name",
        align: "left",
        sortable: true,
        text: "Contractor Name",
      },
      {
        value: "Jobs",
        align: "right",
        sortable: true,
        text: "No of Jobs",
      },
      {
        value: "Misc",
        align: "right",
        sortable: true,
        text: "No of Misc",
      },
      {
        value: "SubTotal",
        align: "right",
        sortable: true,
        text: "Subtotal",
      },
      {
        value: "Toll",
        align: "right",
        sortable: true,
        text: "Toll",
      },
      {
        value: "FuelLevy",
        align: "right",
        sortable: true,
        text: "Fuel Levy",
      },
      {
        value: "GST",
        align: "right",
        sortable: true,
        text: "GST",
      },
      {
        value: "Total",
        align: "right",
        sortable: true,
        text: "Total",
      },
    ],
  }),
  props: ["startDate", "endDate"],

  watch: {
    startDate() {
      this.loadContractorSummary();
    },
    endDate() {
      this.loadContractorSummary();
    },
  },
  created() {
    this.loadContractorSummary();
  },

  computed: {
    jobCount() {
      let jobCount = 0;
      this.contractorSummary.forEach((contractor) => {
        jobCount += contractor.Jobs;
      });
      return this.formatSum(jobCount, "", "0");
    },
    miscCount() {
      let miscCount = 0;
      this.contractorSummary.forEach((contractor) => {
        miscCount += contractor.Misc;
      });
      return this.formatSum(miscCount, "", 0);
    },
    toll() {
      let toll = 0;
      this.contractorSummary.forEach((contractor) => {
        toll += contractor.Toll;
      });
      return this.formatSum(toll, "$");
    },
    fuelLevy() {
      let fuelLevy = 0;
      this.contractorSummary.forEach((contractor) => {
        fuelLevy += contractor.FuelLevy;
      });
      return this.formatSum(fuelLevy, "$");
    },
    gst() {
      let gst = 0;
      this.contractorSummary.forEach((contractor) => {
        gst += contractor.GST;
      });
      return this.formatSum(gst, "$");
    },
    total() {
      let total = 0;
      this.contractorSummary.forEach((contractor) => {
        total += contractor.Total;
      });
      return this.formatSum(total, "$");
    },
    itemsPerPage() {
      if (this.$route.name === "userdashboard") {
        return 20;
      } else {
        return 10;
      }
    },
  },

  methods: {
    loadContractorSummary() {
      this.loadingContractorSummary = true;
      axios
        .get(
          `/summary/contractorsummary?startDate=${this.startDate}&endDate=${this.endDate}`
        )
        .then((response) => {
          this.contractorSummary = response.data;
          this.loadingContractorSummary = false;
        })
        .catch((e) => {
          this.errors.push(e);
          this.loadingContractorSummary = false;
        });
    },
    formatSum(sum, prefix = "", decimal = 2) {
      sum = sum.toFixed(decimal);
      return (
        prefix + " " + sum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      );
    },
  },
};
</script>

<style></style>
